import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { FAQ, FINAL, LINKS, NAV_ITEMS } from "../mock";
import { useReveal, scrollToId } from "../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FaqFinal({ faq = FAQ }) {
  const head = useReveal();
  const acc = useReveal();
  const cta = useReveal();
  return (
    <>
      <section id="faq" className="relative py-24 md:py-28 ocean-bg">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <div ref={head} className="reveal text-center max-w-3xl mx-auto">
            <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Questions fréquentes</p>
            <h2 className="text-4xl md:text-5xl text-white">
              Tu as encore des questions ? <span className="text-gold">J'y réponds !</span>
            </h2>
          </div>

          <div ref={acc} className="reveal mt-12">
            <Accordion type="single" collapsible className="space-y-3">
              {faq.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="glass rounded-2xl px-6 border-none"
                >
                  <AccordionTrigger className="text-left text-white hover:text-[#f6e3a8] hover:no-underline text-[16px] py-5">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/70 leading-relaxed text-[15px] pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            <div className="mt-8 text-center text-white/60">
              Tu as d'autres questions ?{" "}
              <a href={`mailto:${LINKS.email}`} className="text-[#7fd8e8] hover:text-[#f6e3a8] inline-flex items-center gap-1">
                <Mail className="w-4 h-4" /> {LINKS.email}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative py-28 overflow-hidden">
        <div className="absolute inset-0 ocean-bg stars" />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="w-[600px] h-[600px] rounded-full bg-[#1f6f8b]/20 blur-[130px] glow-pulse" />
        </div>
        <div ref={cta} className="reveal relative max-w-4xl mx-auto px-5 md:px-8 text-center">
          <img
            src={FINAL.image}
            alt="Méditation avec les dauphins"
            className="w-56 h-56 md:w-64 md:h-64 object-cover rounded-full ring-1 ring-white/10 mx-auto float-anim"
            loading="lazy"
          />
          <h2 className="mt-10 text-4xl md:text-6xl text-white leading-tight">
            {FINAL.title1}<br />
            <span className="text-shimmer">{FINAL.title2}</span>
          </h2>
          <a
            href={LINKS.inscription}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 btn-gold rounded-full px-8 py-4 font-semibold inline-flex items-center gap-2 group text-lg"
          >
            Je rejoins l'école
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
          <p className="mt-5 text-sm text-white/50">{FINAL.guarantee}</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#040812] border-t border-white/10 py-14">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-10">
          <div>
            <p className="font-[Marcellus] text-lg text-white">École des Maîtres Dauphins</p>
            <p className="mt-3 text-sm text-white/55 max-w-xs">
              Un voyage d'expansion de conscience pour retrouver la joie, la fluidité et le sens.
            </p>
            <p className="mt-4 text-sm text-white/40">By Gilles Delieuze</p>
          </div>
          <div>
            <p className="text-white/80 font-medium mb-4">Navigation</p>
            <ul className="space-y-2">
              {NAV_ITEMS.map((n) => (
                <li key={n.href}>
                  <button onClick={() => scrollToId(n.href)} className="text-sm text-white/55 hover:text-[#f6e3a8] transition-colors">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-white/80 font-medium mb-4">Rejoindre l'aventure</p>
            <a href={LINKS.inscription} target="_blank" rel="noopener noreferrer" className="btn-gold rounded-full px-5 py-2.5 text-sm font-semibold inline-block">
              Je réserve ma place
            </a>
            <a href={`mailto:${LINKS.email}`} className="mt-4 block text-sm text-white/55 hover:text-[#7fd8e8]">
              {LINKS.email}
            </a>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-5 md:px-8 mt-10 pt-6 border-t border-white/5 space-y-4">
          <p className="text-[11px] leading-relaxed text-white/35 text-center max-w-4xl mx-auto">
            Ce site ne fait pas partie du site YouTube™️, Google™️, Facebook™️, Google Inc. ou Facebook Inc.
            De plus, ce site n'est PAS approuvé par YouTube™️, Google™️ ou Facebook™️ en aucune façon.
            FACEBOOK™️ est une marque de commerce de FACEBOOK, Inc. GOOGLE™️ et YOUTUBE™️ sont des marques
            de commerce de GOOGLE Inc.
          </p>
          <p className="text-center text-xs text-white/40">
            © 2024-2033 GILLES DELIEUZE Tous droits réservés
          </p>
        </div>
      </footer>
    </>
  );
}
